import { RouterProvider } from 'react-router-dom';
import { CssBaseline } from '@mui/material';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React, { useEffect } from 'react';
import { ToastContainer, PageLoader } from './components/ui';
import { SnackbarProvider } from './contexts/SnackbarContext';
import { applyClickOutsideBehaviorToAllModals } from './utils/modalUtils';

// Import i18n configuration
import './i18n/i18n';

// Import our custom ThemeProvider instead of MUI's
import { ThemeProvider } from './contexts/ThemeContext';
import { AuthProvider } from './contexts/AuthContext';
import { BreadcrumbProvider } from './contexts/BreadcrumbContext';
import { LanguageProvider } from './contexts/LanguageContext';
import router from './router';

// Pages are now lazy-loaded in the router.tsx file

// Create a client for React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

// Remove hardcoded role
// const userRole: Role = Role.USER_ADMIN; // Example role, replace with actual user role

function App() {
  // Apply click-outside behavior to all modals when the app loads
  useEffect(() => {
    applyClickOutsideBehaviorToAllModals();
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <SnackbarProvider>
          <AuthProvider>
            <LanguageProvider>
              <BreadcrumbProvider>
                <CssBaseline />
                <React.Suspense fallback={<PageLoader />}>
                  <RouterProvider router={router} />
                </React.Suspense>
                <ToastContainer />
              </BreadcrumbProvider>
            </LanguageProvider>
          </AuthProvider>
        </SnackbarProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}

// Route guards and utility components have been moved to router.tsx

export default App;
